import { ONBOARDING_QUALIFICATIONS_DURATION } from "@core/constants";

export const ICandidateExperienceQualification = Object.freeze({
  qualificationId: "qualification_id",
  description: "description",
  name: "name",
  isReferenceable: "is_referenceable",
});

export class CandidateExperienceQualificationModel {
  constructor(data = {}) {
    this[ICandidateExperienceQualification.qualificationId] = data[ICandidateExperienceQualification.qualificationId];
    this[ICandidateExperienceQualification.description] = data[ICandidateExperienceQualification.description];
    this[ICandidateExperienceQualification.name] = data[ICandidateExperienceQualification.name];
    this[ICandidateExperienceQualification.isReferenceable] = data[ICandidateExperienceQualification.isReferenceable];
  }

  getId() {
    return this[ICandidateExperienceQualification.qualificationId];
  }

  getName() {
    return this[ICandidateExperienceQualification.name];
  }

  getDescription() {
    return this[ICandidateExperienceQualification.description];
  }

  isReferenceable() {
    return this[ICandidateExperienceQualification.isReferenceable] === true;
  }

  hasNoExperience() {
    return this[ICandidateExperienceQualification.description] === ONBOARDING_QUALIFICATIONS_DURATION.NO_EXP;
  }
}
